import api from "./axios";

export const galleryApi = {
  // Get all gallery images
  async getImages() {
    try {
      const response = await api.get('/admin/gallery');
      return response.data;
    } catch (error) {
      console.error('Error fetching gallery images:', error);
      throw error;
    }
  },

  // Upload new image
  async uploadImage(formData) {
    try {
      const response = await api.post('/admin/gallery', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading image:', error);
      throw error;
    }
  },

  // Delete image
  async deleteImage(imageId) {
    try {
      const response = await api.delete(`/admin/gallery/${imageId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting image:', error);
      throw error;
    }
  },

  // Update image status (active/inactive)
  async updateImageStatus(imageId, isActive) {
    try {
      const response = await api.patch(`/admin/gallery/${imageId}/status`, {
        is_active: isActive
      });
      return response.data;
    } catch (error) {
      console.error('Error updating image status:', error);
      throw error;
    }
  }
};